"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findLabelByKey = void 0;
const findLabelByKey = key => label => label?.labelKey === key;
exports.findLabelByKey = findLabelByKey;
//# sourceMappingURL=findLabelByKey.js.map